<template>
  <div :style="`height:${tableHeight}px`">
    <el-table
      ref="multipleTable"
      v-loading="taskListLoading"
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      height="100%"
      border
    >
      <el-table-column
        label="序号"
        align="center"
        width="50"
      >
        <template slot-scope="scope">{{ scope.$index+1 }}</template>
      </el-table-column>
      <el-table-column
        prop="taskName"
        label="任务名称"
        align="center"
      />
      <el-table-column
        prop="operateType"
        width="80"
        label="任务类型"
        align="center"
      >
        <template slot-scope="scope">{{ operateType[scope.row.operateType]&&operateType[scope.row.operateType].label }}</template>
      </el-table-column>

      <el-table-column
        prop="taskStatus"
        label="任务状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">{{ taskStatusList[scope.row.taskStatus].label }}</template>
      </el-table-column>
      <el-table-column
        prop="taskResult"
        label="任务信息"
        align="center"
      />
      <el-table-column
        prop="fileName"
        label="任务文件名称"
        align="center"
      />
      <el-table-column
        prop="createTime"
        width="150"
        label="开始时间"
        align="center"
      />
      <el-table-column
        prop="updateTime"
        width="150"
        label="结束时间"
        align="center"
      />
      <el-table-column
        label="操作"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.operateType==='EXPORT'"
            :disabled="scope.row.taskStatus === 'TASK_FAIL' || scope.row.taskStatus === 'TASK_EXECUTE'"
            type="text"
            :loading="scope.row.editLoading"
            @click="handleButton('downloadHandle',scope.row,scope.$index)"
          >下载</el-button>
          <el-button
            v-if="scope.row.operateType==='IMPORT' ||
              scope.row.taskType==='ZQXY_PERSON_PULL'||
              scope.row.taskType==='VERIFY_DEVICE_PULL_PERSON'||
              scope.row.taskType==='BANK_CARD_IMPORT'
            "
            :disabled="scope.row.taskStatus === 'TASK_EXECUTE'"
            type="text"
            @click="handleButton('detailHandle',scope.row,scope.$index)"
          >详情</el-button>
          <el-button
            type="text"
            :disabled="scope.row.taskStatus==='TASK_EXECUTE'"
            @click="handleButton('deleteHandle',scope.row,scope.$index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { taskStatusList } from '../../config'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 100
    },
    loading: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      taskStatusList,
      operateType: {
        IMPORT: {
          label: '导入'
        },
        EXPORT: {
          label: '导出'
        },
        ZQXY: {
          label: '政企协议'
        }
      }
    }
  },
  computed: {
    ...mapState({
      taskListLoading: state => state.user.taskListLoading
    })
  },
  methods: {
    handleSelectionChange(e) {
      this.$emit('handleSelectionChange', e)
    },
    handleButton(emitName, item, index) {
      this.$emit(emitName, item, index)
    },
    getInstance() {
      return this.$refs.multipleTable
    }
  }
}
</script>

<style scoped lang="scss">
.checkboxList{
    display: flex;
    flex-wrap: wrap;
    .el-checkbox{
        width: 50%;
        margin-right: 0;
    }
}
.operation{
    display: inline-block;
    cursor: pointer;
}
</style>
